// extracted by mini-css-extract-plugin
export default {"invited":"styles_invited__HLKPe","active":"styles_active__9mfPo","frozen":"styles_frozen__f4hOF","none":"styles_none__RXI7r","status":"styles_status__UahE4"};